'use client'

import { addSeconds, differenceInSeconds } from 'date-fns'
import { useEffect, useState } from 'react'
import { Countdown } from '@/app/(app)/app/(classroom)/sala/curso/[id]/exam/_components/countdown'

export function PostgraduateCountdown() {
  const startTime = new Date()
  const endTime = addSeconds(new Date(), 2400)

  const [secondsLeft, setSecondsLeft] = useState(() => {
    return Math.max(0, differenceInSeconds(endTime, new Date()))
  })
  const [isOver, setIsOver] = useState(false)

  useEffect(() => {
    const interval = setInterval(() => {
      const now = new Date()
      const totalElapsed = differenceInSeconds(now, startTime)
      if (totalElapsed > 90 * 60) {
        setIsOver(true)
        clearInterval(interval)
        return
      }
      setSecondsLeft(Math.max(0, differenceInSeconds(endTime, now)))
    }, 1000)
    return () => clearInterval(interval)
  }, [startTime, endTime])

  if (isOver) {
    return (
      <div>
        <span style={{ color: 'red', fontWeight: 'bold' }}>
          Já passou do tempo limite!
        </span>
      </div>
    )
  }

  const minutes = Math.floor(secondsLeft / 60)
  const seconds = secondsLeft % 60

  return (
    <span className="font-normal text-[#FBFBFB] text-sm">
      Essa oferta acaba em{' '}
      <span className="font-semibold">
        {minutes.toString().padStart(2, '0')}:
        {seconds.toString().padStart(2, '0')}
      </span>
    </span>
  )
}
